import { Text } from '@tiendanube/components';
import FeatureFlag from 'App/components/FeatureFlag';
import { PAYM_ABANDONED_CARTS } from 'App/featuresFlags';
import { Layout, useResponsive } from 'commons/components';
import {
  CustomerDataCardSkeleton,
  DetailsHeaderSkeleton,
  OrderSummaryCardSkeleton,
} from 'domains/Orders/components';
import { BillingAddressCardSkeleton } from '../BillingAddressCard';
import { CardPaymentSkeleton } from '../CardPayment/CardPaymentSkeleton';
import { DeliveryInfoCardSkeleton } from '../DeliveryInfoCard';
import { PaymentAttemptsCardSkeleton } from '../PaymentAttemptsCard/PaymentAttemptsCardSkeleton';
import { SendEmailAbandonedCartCardSkeleton } from '../SendEmailAbandonedCartCard';
import { ShareAbandonedCartCardSkeleton } from '../ShareAbandonedCartCard';

function AbandonedCartDetailsSkeleton() {
  const { isDesktop } = useResponsive();

  return (
    <Layout
      mainContent
      right={
        <>
          {isDesktop && <Text.Skeleton />}
          <CustomerDataCardSkeleton />
          <DeliveryInfoCardSkeleton />
          <BillingAddressCardSkeleton />
        </>
      }
      left={
        <>
          <DetailsHeaderSkeleton isOrder={false} />
          <ShareAbandonedCartCardSkeleton />
          <SendEmailAbandonedCartCardSkeleton />
          <FeatureFlag
            flag={PAYM_ABANDONED_CARTS}
            renderElse={<CardPaymentSkeleton />}
          >
            <PaymentAttemptsCardSkeleton />
          </FeatureFlag>
          <OrderSummaryCardSkeleton />
        </>
      }
    />
  );
}

export default AbandonedCartDetailsSkeleton;
